<template>
	<div class="ModalContextMenuComponent" @keydown.esc="escKeyPressedHandler">
		<div class="context-menu d-block position-absolute border bg-white p-2">
			<template v-for="(iconGroup) in icons">
				<template v-for="(icon) in iconGroup">
					<i v-if="icon.show != undefined ? icon.show : true" :key="icon.title" :class="icon.classes" @click="icon.clickFn($event)" :title="icon.title ? icon.title : ''"></i>
				</template>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	props: ['icons'],

	data() {
		return {
		};
	},

	methods: {
		escKeyPressedHandler() {
			this.$emit('escKeyPressed');
		},
	},
};
</script>

<style lang="scss">
	.context-menu {
		box-shadow: 1px 1px 3px #999;
	}
</style>
